import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import {
  Box,
  ComponentMultiStyleConfig,
  Td,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";

export type CMSearchResultCellFrameProps = {
  isNumeric?: boolean;

  children: ReactNode;
} & ComponentStyleProps;

export const CMSearchResultCellFrame = ({
  isNumeric = false,

  children,

  sx,
  ...rest
}: CMSearchResultCellFrameProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellFrameStyles");
  return (
    <Td isNumeric={isNumeric} sx={{ ...styles.container, ...sx }} {...rest}>
      <Box sx={styles.wrap} className={"Wrap"}>
        {children}
      </Box>
    </Td>
  );
};

export const CMSearchResultCellFrameStyles: ComponentMultiStyleConfig = {
  parts: ["container", "wrap"],
  baseStyle: {
    container: {
      // borderTopWidth: "0",
      // borderRightWidth: "0",
      // borderBottomWidth: "0",
      // borderLeftWidth: "0",
      borderWidth: "0",
      // borderColor: "gray.200",
      fontSize: "sm",

      overflowX: "hidden",
      overflowY: "auto",

      wordBreak: "break-all",

      minW: "40px",
      maxW: "280px",

      pl: "10px",
      pr: "8px",
      py: "8px",
    },
    wrap: {
      // pl: "4",
      // pr: "4",
      // py: "3",

      h: "max-content",
      maxH: "140px",

      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
  },
};
